/// <reference path="../app.ts" />
namespace Cfnc {
    export class Alpha {
        static filterId: string = "alpha";

        static filter() {
            return function(items: Array<any>, property: string, startsWith: string) {
                if (property && startsWith) {
                    var result: Array<any> = [];

                    for (var i = 0; i < items.length; i++) {
                        if (items[i][property].toLowerCase().indexOf(startsWith.toLowerCase()) == 0) {
                            result.push(items[i]);
                        }
                    }
                    return result;
                }
                else {
                    return items;
                }
            }
            }
    }
    angular.module("app").filter(Alpha.filterId, [Alpha.filter]);
}